export default class UiManagers {
}
UiManagers.STYLE_MANAGER = "STYLE_MANAGER";
